export default {
  brand: {
    name: 'PageDrop',
    tagline: 'Drop to preview',
  },
  nav: {
    home: 'Home',
    records: 'My Records',
  },
  theme: {
    light: 'Light mode',
    dark: 'Dark mode',
    system: 'Follow system',
  },
  lang: {
    switchTo: '切换到中文',
  },
  auth: {
    login: 'Sign in with Yifang Toolbox account',
    logout: 'Sign out',
    loginPromptTitle: 'Sign in to upload',
    loginPromptDesc:
      'Selecting and uploading files requires a Yifang Toolbox account — you cannot pick files or upload without signing in. Sign in to drop files and keep your records saved automatically.',
    notNow: 'Not now',
    loginRequiredTitle: 'Sign in to view your records',
    loginRequiredDesc:
      'Sign in with your unified Yifang Toolbox account to see your history and storage quota.',
    reauth: 'Re-authorize',
    reauthDesc:
      'Your current grant is missing the storage scope. Re-authorize to enable uploads and quota.',
    callbackTitle: 'Sign-in failed',
    errorPrefix: 'Error',
    retry: 'Retry sign-in',
    backHome: 'Back to home',
  },
  home: {
    heroBadge: 'No more downloading HTML from requirement docs',
    h1a: 'Turn HTML prototypes',
    h1b: 'into one shareable link',
    sub: 'Drag & drop an HTML file or a whole prototype folder (CSS / JS / images included) and get an instant online preview link — paste it into requirement docs, IM or email and it just opens.',
    howTitle: 'Three steps, done',
    step1t: 'Drop your files',
    step1d: 'A single HTML file, or a prototype folder with CSS, JS and images.',
    step2t: 'Get a link',
    step2d: 'A shareable preview URL is generated as soon as the upload completes.',
    step3t: 'Paste it anywhere',
    step3d: 'Open the link to view the interactive prototype — no attachments to download.',
    featTitle: 'Built for collaboration',
    f1t: 'Interactive preview',
    f1d: 'Pages render exactly as authored, with JS interactions intact.',
    f2t: 'Full static assets',
    f2d: 'CSS, JS, images and fonts — folder structure preserved as-is.',
    f3t: 'Bilingual & dark mode',
    f3d: 'Chinese/English UI, light/dark/system themes, responsive on mobile and desktop.',
    f4t: 'Your history',
    f4d: 'Sign in with your Yifang Toolbox account — every upload is saved automatically.',
    formats: 'HTML / CSS / JS / images / fonts and other web assets supported',
  },
  dropzone: {
    hint: 'Drop an HTML file or a whole folder here (all subfolders included)',
    pickFiles: 'Choose files',
    pickFolder: 'Choose folder',
    entryBadge: 'Entry',
    setEntry: 'Set as entry',
    total: '{{count}} of {{all}} files selected · {{size}}',
    autoSkipped: '{{count}} files auto-excluded (.git, node_modules, non-web assets…). Tick them to include anyway.',
    expandAll: 'Expand all',
    collapseAll: 'Collapse all',
    clear: 'Clear',
    uploadBtn: 'Upload & save to records',
    updateBtn: 'Upload & overwrite',
    updateNote: 'Updating "{{name}}": this upload replaces all project files; the preview link stays the same.',
    uploadSoon: 'Direct upload & preview service arrives in the next phase',
    noHtml: 'No HTML file among the ticked files — tick at least one .html page',
    noSelected: 'Nothing ticked yet — tick the files or folders to upload in the list below',
    toggleFolder: 'Expand/collapse folder {{name}}',
    includeDir: 'Include folder {{name}}',
    includeFile: 'Upload file {{name}}',
  },
  upload: {
    checking: 'Checking storage quota…',
    uploading: 'Uploading {{name}}',
    uploadingMany: 'Uploading {{count}} files in parallel ({{name}}…)',
    cancel: 'Cancel upload',
    cancelled: 'Upload cancelled. Files already uploaded still count against your quota.',
    saving: 'Saving record…',
    successTitle: 'Upload complete, record saved',
    successDesc: 'File sizes counted into your storage quota. The preview link is ready to paste into your docs.',
    viewRecords: 'View my records',
    openPreview: 'Open preview',
    uploadMore: 'Upload more',
    quotaExceeded: 'Not enough storage quota: {{remaining}} left, {{need}} more needed.',
    buyQuota: 'Buy quota on the main site',
    fileTooLarge: '{{name}} exceeds the 500MB single-file limit',
    uploadNotEnabled: 'Direct upload is not enabled for this app (an R2 bucket must be registered by the admin)',
    putFailed: 'Failed to upload {{name}} (size or type mismatch with the credential), please retry',
    saveFailed: 'Failed to save the record, but files are uploaded and billed. Please refresh and retry later.',
    updateFailed: 'Failed to update the project, but new files are uploaded and billed. Please retry later.',
    updateNotFound: 'Project not found or not yours. Go back to records, refresh, and retry.',
    updateSuccessTitle: 'Update complete, preview refreshed',
    updateSuccessDesc: 'All files overwritten and cache invalidated — open the preview to see the latest version.',
    backToRecords: 'Back to records',
    updateMore: 'Update again',
    networkError: 'Network error, please retry',
    reauthNeeded: 'Your session expired or the grant is insufficient, please sign in again',
    retry: 'Retry',
  },
  records: {
    title: 'My Records',
    uploadNew: 'Upload new',
    update: 'Update',
    quota: 'Storage quota',
    quotaUsed: '{{used}} of {{total}} used',
    quotaRemaining: '{{size}} remaining',
    pending: '{{size}} pending',
    files: '{{count}} files',
    entry: 'Entry',
    preview: 'Preview',
    copyLink: 'Copy link',
    copied: 'Copied',
    loadFailed: 'Failed to load records, please refresh',
    empty: 'No records yet',
    emptyHint: 'Your uploads and preview links will appear here after your first upload.',
    goUpload: 'Upload now',
  },
  updatePage: {
    title: 'Update project',
    titleNamed: 'Update project: {{name}}',
    back: 'Back to records',
    notFound: 'Project not found or not accessible',
  },
  footer: {
    slogan: 'Every prototype review should start with a link.',
    note: 'A subsite of the <0>Yifang Toolbox</0> · Unified Yifang Toolbox sign-in',
  },
  notfound: {
    title: 'Page not found',
    desc: 'The page you are looking for does not exist or has been removed.',
    back: 'Back to home',
  },
  seo: {
    homeTitle: 'PageDrop · Instant HTML Prototype Preview',
    homeDesc:
      'Drag & drop HTML prototypes with CSS/JS/images to get an instant online preview link — paste it into requirement docs and open it directly, no downloads.',
    recordsTitle: 'My Records · PageDrop',
    recordsDesc: 'View your uploaded HTML prototypes, preview links and storage quota.',
    updateTitle: 'Update project · PageDrop',
    notFoundTitle: 'Page not found · PageDrop',
  },
}
